import { render, staticRenderFns } from "./VCores.vue?vue&type=template&id=42691086&"
import script from "./VCores.vue?vue&type=script&lang=js&"
export * from "./VCores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports